import type { MetaFunction } from 'react-router';

import { getRepubMetaFromRepub } from '~/vendor/cx-web/utils';
import { getCanonicalURL } from '~/vendor/cx-web/utils/getCanonicalURL';

import { type loader } from './loader';

export const meta: MetaFunction<never, { [routeId: string]: typeof loader }> = ({ location, matches }) => {
  const layoutMatch = matches.find(match => /layout$/.test(match.id));
  const repub = layoutMatch?.data?.repub;
  const data = matches.find(match => /positive-ev$/.test(match.id))?.data;

  if (!repub) {
    throw new Error('Repub data is missing from layout match');
  }

  const { repubIs } = getRepubMetaFromRepub(repub);

  const brandName = repubIs.WS ? 'WhoScored Plus' : 'Oddschecker Plus';

  return [
    {
      title: repubIs.OC ? `Value Bets | ${brandName}` : `Positive EV Betting Tool - Value Bets | ${brandName}`,
    },
    {
      name: 'description',
      content: repubIs.OC ? `Value Bets | ${brandName}` : `Positive EV Betting Tool - Value Bets | ${brandName}`,
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: getCanonicalURL(data?.url.toString(), location.pathname),
    },
  ];
};
